exports = module.exports = require("./../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "#footer{position:relative;height:300px;padding:60px;background:#fff}#copyright{position:absolute;font-size:.8em;padding:1em;bottom:0;left:0;width:100%;opacity:.8}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-rewriter.js?id=data-v-6bd3ca22!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/DashboardFooter.vue
// module id = 144
// module chunks = 0